import Vuex from 'vuex'
import Vue from 'vue'
import ui from './modules/ui'
import space from './modules/space'
import spaceEdit from './modules/space-edit'
import search from './modules/search'
import user from './modules/user'
import mapFunctions from './modules/mapFunctions'
import mapLabels from './modules/mapLabels'
import mapEvents from './modules/mapEvents'
import mapSymbols from './modules/mapSymbols'
import dv from './modules/dv'
import association from './modules/association'
import lists from './modules/lists'
import colorRooms from './modules/colorRooms'
import dashboard from './modules/dashboard'
import restServices from './modules/restServices'
import measurement from './modules/measurement'
import roomViewer from './modules/roomViewer'
import amenities from './modules/amenities'
import roomCollections from './modules/roomCollections'


Vue.use(Vuex)

export default new Vuex.Store({
  modules:  { 	ui, 
  				space, 
  				spaceEdit, 
  				search, 
  				user, 
  				mapFunctions, 
          mapLabels,
          mapEvents,
          mapSymbols,
  				dv,
  				association,
  				lists,
          colorRooms,
          dashboard,
		      restServices,
		      measurement,
          roomViewer,	
          amenities,
          roomCollections,
  			}

})





// WEBPACK FOOTER //
// ./src/store/index.js